import { gql } from "@apollo/client";

export const SEND_EMAIL_NOTIFICATION = gql`
mutation SendEmailNotification($input: NotificationInput) {
    sendEmailNotification(input: $input) {
        success
        message
    }
}`